import { createContext } from 'react'

export const TrackingContext = createContext<TrackEventCallback | undefined>(undefined)
